import { Routes, Route, Navigate } from 'react-router-dom';
import { Grid } from '@mui/material';

import Navbar from '../navbar/Navbar';
import { ProtectedRoutes } from '../ProtectedRoutes';
import Users from '../users/Users';
import Collections from '../collections/Collections';
import CollectionsCreate from '../collections/CollectionsCreate';
import CollectionsEditForm from '../collections/CollectionsEditForm';
import Deploy from '../deploy/Deploy';
import Releases from '../releases/Releases';
import Notification from '../UI/notification/Notification';

import AppBar from '../appbar/AppBar';

import styles from './App.module.scss';

const App = () => {
  return (
    <Grid container className={styles['app']}>
      <AppBar />
      <Navbar />
      <Routes>
        <Route element={<ProtectedRoutes />}>
          <Route index path="/" element={<Navigate to="/users" />} />
          <Route path="/users" element={<Users />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/collections/create" element={<CollectionsCreate />} />
          <Route path="/collections/:id" element={<CollectionsEditForm />} />
          <Route path="/deploy" element={<Deploy />} />
          <Route path="/releases" element={<Releases />} />
          <Route path="*" element={<p>404</p>} />
        </Route>
      </Routes>
      <Notification />
    </Grid>
  );
};

export default App;
